function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { media } from "sprout-ui-theme";
import { Text, Flex } from "sprout-ui-primitives";
import useToggle from "@sprout/hooks/dist/useToggle";
import { usePostPage_UpdateTodoListMutation, ItemType } from "sprout-graphql";
import { useNavigationListContext } from "@sprout/list-navigation";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import PostPageCommentCount from "../PostPageCommentCount";
import { usePostPageEditor } from "../PostPageEditorContext";
import PostPageTodoListMenu from "./PostPageTodoListMenu";
import PostPageTodoListEditor from "./PostPageTodoListEditor";
const PostPageTodoListTitleWrapper = styled(Flex)`
  position: relative;

  ${media.up("medium", "pointer")} {
    :hover {
      .PostPageTodoListMenu {
        opacity: 1;
      }
    }
  }

  ${({ $menu  })=>$menu && css`
      .PostPageTodoListMenu {
        opacity: 1;
      }
    `}
`;
const StyledFlex = styled(Flex)`
  ${({ $editable  })=>$editable && `cursor: pointer`}
`;
const StyledText = styled(Text)`
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;
const PostPageTodoListTitle = (props)=>{
    const { todoList , disabled , pressToEdit , // archiveTodoList,
    // deleteTodoList,
    navigationListItemProvided ,  } = props;
    const { id , nodeId , description , commentCount ,  } = todoList;
    const { state , dispatch  } = usePostPageEditor();
    const openTodoListEditEditorToUpdate = state.editor === "EDIT_TODOLIST" && state.editorPosition === id;
    //
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { dispatchCommand  } = useNavigationListContext();
    const openEdit = useCallback(()=>{
        dispatchCommand("EDIT_TODOLIST", todoList);
    }, [
        dispatchCommand,
        todoList
    ]);
    const closeEdit = useCallback(()=>{
        dispatch({
            type: "CLOSE_EDITOR"
        });
    }, [
        dispatch
    ]);
    //
    const [menu, openMenu, closeMenu] = useToggle();
    const [updateTodoList] = usePostPage_UpdateTodoListMutation();
    const showSnackbar = useSnackbar();
    const handleSubmit = useCallback((nextDescription)=>{
        if (nextDescription !== description && nextDescription.length !== 0) updateTodoList({
            variables: {
                itemId: id,
                description: nextDescription
            },
            optimisticResponse: {
                updateItemById: {
                    item: {
                        id,
                        nodeId,
                        type: ItemType.Checklist,
                        description: nextDescription,
                        completed: false,
                        completedAt: null,
                        url: null,
                        __typename: "Item"
                    },
                    __typename: "UpdateItemPayload"
                }
            }
        }).catch(()=>{
            showSnackbar.error();
        });
        closeEdit();
    }, [
        closeEdit,
        description,
        id,
        nodeId,
        showSnackbar,
        updateTodoList
    ]);
    const editable = pressToEdit && !disabled;
    const as = _objectSpread({}, !pressToEdit && {
        as: Link,
        to: `/todolist/${id}`
    });
    const { helpers , navProps  } = navigationListItemProvided || {};
    const { isActive =false  } = helpers || {};
    return /*#__PURE__*/ _jsxs(PostPageTodoListTitleWrapper, _objectSpread({
        $menu: menu,
        mx: -1
    }, navProps, {
        children: [
            !openTodoListEditEditorToUpdate ? /*#__PURE__*/ _jsxs(StyledFlex, _objectSpread({
                px: 1,
                py: "10px",
                alignItems: "center",
                bg: isActive ? "rgba(25, 118, 210, 0.04)" : undefined,
                borderRadius: "6px",
                flex: "1",
                minWidth: "0",
                onClick: editable ? openEdit : undefined
            }, as, {
                $editable: !!editable,
                children: [
                    /*#__PURE__*/ _jsx(StyledText, {
                        as: "span",
                        fontSize: pressToEdit ? "34px" : "18px",
                        lineHeight: pressToEdit ? undefined : "20px",
                        fontWeight: "bold",
                        children: description
                    }),
                    commentCount > 0 && /*#__PURE__*/ _jsx(PostPageCommentCount, {
                        children: commentCount
                    })
                ]
            })) : /*#__PURE__*/ _jsx(Flex, {
                flex: "1",
                flexDirection: "column",
                mt: 3,
                children: /*#__PURE__*/ _jsx(PostPageTodoListEditor, {
                    initialInputValue: description || "To-do list",
                    onSubmit: handleSubmit,
                    onCancel: closeEdit
                })
            }),
            !pressToEdit && !disabled && !openTodoListEditEditorToUpdate && /*#__PURE__*/ _jsx(PostPageTodoListMenu, {
                todoList: todoList,
                onOpen: openMenu,
                onClose: closeMenu
            })
        ]
    }));
};
export default PostPageTodoListTitle;
